// add special class to element that was focused if focus moved via keyboard
// WEB-6611
;(function ($, window, document) {
  function onDOMContentLoaded() {
    $(window).keydown(function (event) {
      window.keyDown = true
      // was tab or arrow key pressed?
      if (
        !event.metaKey &&
        (event.which == 9 || (event.which >= 37 && event.which <= 40))
      ) {
        var focused = $(':focus')

        if (event.which > 9 && !focused.is('input[type=radio]')) {
          return
        }

        if (focused && focused.hasClass('keyboard-focus')) {
          focused.removeClass('keyboard-focus')
        }
        focused = $('.keyboard-focus').not('.field')
        if (focused) {
          focused.removeClass('keyboard-focus')
        }

        // find focused element
        setTimeout(function () {
          focused = $(':focus')
          focused.addClass('keyboard-focus')
        }, 10)
      }
    })
    $(window).keyup(function () {
      window.keyDown = false
    })
    $(window).focusout(function () {
      // remove keyboard-focus class from any element. nothing is in focus
      var focused = $('.keyboard-focus')
      if (focused && focused.hasClass('keyboard-focus')) {
        focused.removeClass('keyboard-focus')
      }
    })
  }
  if (document.readyState == 'loading') {
    document.addEventListener("DOMContentLoaded", onDOMContentLoaded);
  } else {
    onDOMContentLoaded();
  }
})(jQuery, window, document)
